import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"
import _imports_0 from '@/assets/img/add-image.svg'


const _hoisted_1 = { class: "grid grid-cols-1 sm:grid-cols-2 md:gap-8 gap-0" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", {
  for: "additionalFeeDescId",
  class: "color-blue-grey"
}, "Keterangan Biaya Tambahan", -1)
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", {
  for: "ketPengakuanId",
  class: "color-blue-grey"
}, "Keterangan Pengakuan", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("small", { class: "color-red" }, "*Harus diisi", -1)
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", {
  for: "labelIdSelect",
  class: "color-blue-grey"
}, "Pilih Label", -1)
const _hoisted_9 = { class: "multiselect-single-label" }
const _hoisted_10 = /*#__PURE__*/_createVNode("small", { class: "color-red" }, "*Pilih label terlebih dahulu agar dapat memilih stok pada label", -1)
const _hoisted_11 = { class: "mb-8" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", {
  for: "labelId",
  class: "color-blue-grey"
}, "Stok Label", -1)
const _hoisted_13 = { class: "flex gap-2 mt-1" }
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "overflow-y-auto px-2",
  style: {"max-height":"9rem","min-width":"18rem"}
}
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "my-no-more" }, null, -1)
const _hoisted_17 = {
  key: 1,
  class: "py-4"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("p", { class: "text-center color-blue-grey font-medium text-sm" }, " Pencarian tidak ditemukan ", -1)
const _hoisted_19 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_20 = { class: "text-black text-lg font-bold" }
const _hoisted_21 = { class: "flex w-full flex-wrap mt-1" }
const _hoisted_22 = { class: "text-center font-bold text-white" }
const _hoisted_23 = { class: "mb-5 mt-0" }
const _hoisted_24 = { class: "flex items-center" }
const _hoisted_25 = { class: "mr-2 flex-1" }
const _hoisted_26 = { class: "flex items-center justify-between w-1/3 lg:w-auto" }
const _hoisted_27 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "lg:h-6 lg:w-6 h-10 w-10",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  focusable: "false",
  style: {"-ms-transform":"rotate(360deg)","-webkit-transform":"rotate(360deg)","transform":"rotate(360deg)"},
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("g", { fill: "none" }, [
    /*#__PURE__*/_createVNode("path", {
      d: "M16.34 9.322a1 1 0 1 0-1.364-1.463l-2.926 2.728L9.322 7.66A1 1 0 0 0 7.86 9.024l2.728 2.926l-2.927 2.728a1 1 0 1 0 1.364 1.462l2.926-2.727l2.728 2.926a1 1 0 1 0 1.462-1.363l-2.727-2.926l2.926-2.728z",
      fill: "#F44336"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12zm11 9a9 9 0 1 1 0-18a9 9 0 0 1 0 18z",
      fill: "#F44336"
    })
  ])
], -1)
const _hoisted_28 = { class: "mb-5" }
const _hoisted_29 = /*#__PURE__*/_createVNode("label", {
  for: "additionalCostId",
  class: "color-blue-grey"
}, "Biaya Tambahan Resi", -1)
const _hoisted_30 = { class: "mb-5" }
const _hoisted_31 = /*#__PURE__*/_createVNode("label", {
  for: "customerDiscountId",
  class: "color-blue-grey"
}, "Diskon Pelanggan", -1)
const _hoisted_32 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("label", {
  for: "priceRecognitionId",
  class: "color-blue-grey"
}, "Pengakuan Harga barang", -1)
const _hoisted_34 = {
  key: 1,
  class: "mb-5"
}
const _hoisted_35 = /*#__PURE__*/_createVNode("label", {
  for: "costInsuranceIdText",
  class: "color-blue-grey"
}, "Biaya asuransi (harga barang x Persentase asuransi)", -1)
const _hoisted_36 = { key: 2 }
const _hoisted_37 = { class: "flex items-center justify-between mb-3" }
const _hoisted_38 = /*#__PURE__*/_createVNode("p", { class: "text-sm" }, "Foto Barang", -1)
const _hoisted_39 = { class: "grid lg:grid-cols-5 grid-cols-2 md:grid-cols-3 gap-3" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = {
  key: 1,
  class: "grid md:grid-cols-3 grid-cols-2 lg:grid-cols-5 gap-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_VueEternalLoading = _resolveComponent("VueEternalLoading")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_InputNumber = _resolveComponent("InputNumber")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", null, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_Textarea, {
            autoResize: true,
            id: "additionalFeeDescId",
            modelValue: _ctx.additionalFeeDesc,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.additionalFeeDesc = $event)),
            rows: "2",
            class: "w-full rounded-lg input-primary mb-0 mt-1",
            placeholder: "Keterangan Biaya Tambahan",
            disabled: _ctx.isMiisi
          }, null, 8, ["modelValue", "disabled"])
        ]),
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_Textarea, {
            autoResize: true,
            id: "ketPengakuanId",
            modelValue: _ctx.description,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.description = $event)),
            rows: "2",
            class: "w-full rounded-lg input-primary mb-0 mt-1",
            placeholder: "Keterangan Pengakuan"
          }, null, 8, ["modelValue"]),
          _hoisted_6
        ]),
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_Multiselect, {
            id: "labelIdSelect",
            modelValue: _ctx.labelIdSelect,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.labelIdSelect = $event)),
            searchable: true,
            class: "input-primary w-full mb-1",
            options: _ctx.groupLabel,
            placeholder: "Pilih label"
          }, {
            singlelabel: _withCtx(({ value }) => [
              _createVNode("div", _hoisted_9, [
                _createVNode("p", {
                  class: "font-semibold cursor-pointer",
                  style: { color: value.color }
                }, _toDisplayString(value.label), 5)
              ])
            ]),
            option: _withCtx(({ option }) => [
              _createVNode("p", {
                class: "font-semibold cursor-pointer",
                style: { color: option.color }
              }, _toDisplayString(option.label), 5)
            ]),
            _: 1
          }, 8, ["modelValue", "options"]),
          _hoisted_10
        ]),
        _createVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode("div", _hoisted_13, [
            _createVNode(_component_InputText, {
              id: "inputStockLabel",
              class: "input-primary rounded-lg w-full",
              modelValue: _ctx.labelInput,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.labelInput = $event)),
              placeholder: "Pilih Stock",
              onKeypress: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.changeValueLabelInput(_ctx.labelInput, $event)), ["enter"]))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Button, {
              class: "btn-primary",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeValueLabelInput(_ctx.labelInput, $event)))
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }),
            _createVNode(_component_OverlayPanel, { ref: "op" }, {
              default: _withCtx(() => [
                (_ctx.labelOption.length > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_15, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.labelOption, (item, index) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "mx-4 py-2 cursor-pointer",
                          style: {"border-bottom":".5px solid rgba(0,0,0,.3)"},
                          onClick: ($event: any) => (_ctx.clickPlace(item)),
                          key: 'go' + index
                        }, [
                          _createVNode("p", {
                            style: { color: item.color }
                          }, _toDisplayString(item.label), 5)
                        ], 8, ["onClick"]))
                      }), 128)),
                      _createVNode(_component_VueEternalLoading, {
                        load: _ctx.loadData,
                        "is-initial": _ctx.isInitial,
                        "onUpdate:is-initial": _cache[7] || (_cache[7] = ($event: any) => (_ctx.isInitial = $event)),
                        class: "flex justify-center"
                      }, {
                        loading: _withCtx(() => [
                          _createVNode(_component_ProgressSpinner, {
                            class: "h-14",
                            strokeWidth: "5"
                          })
                        ]),
                        "no-more": _withCtx(() => [
                          _hoisted_16
                        ]),
                        _: 1
                      }, 8, ["load", "is-initial"])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_17, [
                      _hoisted_18
                    ]))
              ]),
              _: 1
            }, 512)
          ]),
          (_ctx.label.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_19, [
                _createVNode("p", _hoisted_20, _toDisplayString(`Total Label Yang Dipilih ${_ctx.label.length}`), 1),
                _createVNode("div", _hoisted_21, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.label, (data, index) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "flex justify-center p-1 cursor-pointer mr-3 px-2 items-center gap-2 my-1",
                      style: [`background: ${data.color};`, {"border-radius":"6px"}],
                      key: data.value
                    }, [
                      _createVNode("p", _hoisted_22, _toDisplayString(`${index + 1}. ${data.label}`), 1),
                      _createVNode("i", {
                        class: "pi pi-times text-white hover:text-black text-sm",
                        onClick: ($event: any) => (_ctx.deleteLabel(index))
                      }, null, 8, ["onClick"])
                    ], 4))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_23, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataItemsSticker, (data, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "flex mb-5 items-center",
              key: index
            }, [
              _createVNode("div", _hoisted_24, [
                _createVNode("div", _hoisted_25, [
                  _createVNode(_component_Multiselect, {
                    id: `labelId${index}`,
                    class: "mt-1 w-full rounded-lg",
                    modelValue: data.stickerId,
                    "onUpdate:modelValue": ($event: any) => (data.stickerId = $event),
                    modelModifiers: { lazy: true },
                    placeholder: "Pilih Stiker",
                    options: data.stickerOption,
                    "allow-empty": false,
                    searchable: true
                  }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "options"])
                ]),
                _createVNode("div", _hoisted_26, [
                  _createVNode(_component_InputNumber, {
                    class: "input-primary rounded-lg mr-2 lg:mr-0",
                    id: `horizontal${index}`,
                    showButtons: "",
                    buttonLayout: "horizontal",
                    modelValue: data.value,
                    "onUpdate:modelValue": ($event: any) => (data.value = $event),
                    modelModifiers: { lazy: true },
                    incrementButtonIcon: "pi pi-plus",
                    decrementButtonIcon: "pi pi-minus",
                    disabled: _ctx.isMiisi
                  }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "disabled"]),
                  _createVNode(_component_Button, {
                    class: "p-button-link px-1",
                    onClick: ($event: any) => (_ctx.deleteSticker(index))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_27
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ])
            ]))
          }), 128)),
          _createVNode("p", {
            class: "text-center color-primary font-bold md:text-lg text-base cursor-pointer mt-5",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.tambahSticker && _ctx.tambahSticker(...args)))
          }, " + Tambah Jenis Sticker ")
        ])
      ]),
      _createVNode("div", null, [
        _createVNode("div", _hoisted_28, [
          _hoisted_29,
          _createVNode(_component_InputNumber, {
            id: "additionalCostId",
            class: "input-primary rounded-lg w-full mt-1",
            modelValue: _ctx.additionalCost,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.additionalCost = $event)),
            modelModifiers: { lazy: true },
            mode: "currency",
            currency: "IDR",
            locale: "id-ID",
            disabled: _ctx.isMiisi
          }, null, 8, ["modelValue", "disabled"])
        ]),
        _createVNode("div", _hoisted_30, [
          _hoisted_31,
          _createVNode(_component_InputText, {
            id: "customerDiscountId",
            class: "input-primary rounded-lg w-full mt-1",
            modelValue: _ctx.customerDiscount,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.customerDiscount = $event)),
            placeholder: "Diskon Pelanggan",
            readonly: "",
            disabled: _ctx.isMiisi
          }, null, 8, ["modelValue", "disabled"])
        ]),
        (_ctx.isHaveInsurance)
          ? (_openBlock(), _createBlock("div", _hoisted_32, [
              _hoisted_33,
              _createVNode(_component_InputNumber, {
                id: "priceRecognitionId",
                class: "input-primary rounded-lg w-full mt-1",
                modelValue: _ctx.priceRecognition,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.priceRecognition = $event)),
                modelModifiers: { lazy: true },
                mode: "currency",
                currency: "IDR",
                locale: "id-ID",
                disabled: _ctx.isMiisi
              }, null, 8, ["modelValue", "disabled"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isHaveInsurance)
          ? (_openBlock(), _createBlock("div", _hoisted_34, [
              _hoisted_35,
              _createVNode(_component_InputText, {
                id: "costInsuranceIdText",
                class: "input-primary rounded-lg w-full mt-1",
                modelValue: _ctx.costInsuranceText,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.costInsuranceText = $event)),
                placeholder: "Biaya Asuransi",
                readonly: "",
                disabled: _ctx.isMiisi
              }, null, 8, ["modelValue", "disabled"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isHaveInsurance)
          ? (_openBlock(), _createBlock("div", _hoisted_36, [
              _createVNode("div", _hoisted_37, [
                _hoisted_38,
                (_ctx.checkSrcListImage() < 5)
                  ? (_openBlock(), _createBlock("p", {
                      key: 0,
                      class: "font-semibold color-blue-grey lg:text-base md:text-base text-sm underline",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.resetImage()))
                    }, " Reset "))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.$store.state.device.isMobile)
                ? (_openBlock(), _createBlock("div", {
                    key: 0,
                    class: "list-photo",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showCamera()))
                  }, [
                    _createVNode("div", _hoisted_39, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listImage, (item, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: 'image-' + index,
                          class: "relative mb-3"
                        }, [
                          (item.src === null)
                            ? (_openBlock(), _createBlock("img", {
                                key: 0,
                                class: "w-full",
                                src: _imports_0,
                                alt: item.name
                              }, null, 8, ["alt"]))
                            : (_openBlock(), _createBlock("img", {
                                key: 1,
                                class: "w-full object-cover md:h-28 lg:h-20 h-36 rounded-lg",
                                src: item.src,
                                alt: item.name
                              }, null, 8, ["src", "alt"]))
                        ]))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _mergeProps({ key: 1 }, _ctx.getRootProps()), [
                    _createVNode("input", _ctx.getInputProps(), null, 16),
                    (_ctx.isDragActive)
                      ? (_openBlock(), _createBlock("p", _hoisted_40, "Drop the files here ..."))
                      : (_openBlock(), _createBlock("div", _hoisted_41, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listImage, (item, index) => {
                            return (_openBlock(), _createBlock("div", {
                              key: 'image-' + index,
                              class: "relative mb-3"
                            }, [
                              (item.src === null)
                                ? (_openBlock(), _createBlock("img", {
                                    key: 0,
                                    class: "w-full",
                                    src: _imports_0,
                                    alt: item.name
                                  }, null, 8, ["alt"]))
                                : (_openBlock(), _createBlock("img", {
                                    key: 1,
                                    class: "w-full object-cover md:h-28 lg:h-20 h-36 rounded-lg",
                                    src: item.src,
                                    alt: item.name
                                  }, null, 8, ["src", "alt"]))
                            ]))
                          }), 128))
                        ]))
                  ], 16))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}